import { Box } from "@mui/material";

export const TabsIndicators = ({ stepsLength, currentStep }: { stepsLength: number; currentStep: number }) => {
  return (
    <Box sx={styles.progressContainer}>
      {Array.from({ length: stepsLength }, (_, index) => (
        <Box key={index} sx={styles.progressLine(currentStep >= index + 1)} />
      ))}
    </Box>
  );
};

const styles = {
  progressContainer: {
    display: "flex",
    gap: "4px",
    width: "100%",
  },
  progressLine: (isCompleted: boolean) => ({
    flex: 1,
    height: "4px",
    backgroundColor: isCompleted ? "var(--Brand-600, #008B07)" : "var(--Gray-200, #E4E7EC)",
    borderRadius: "2px",
  }),
};
